import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import Calendly from './Calendly'

function Footer(props) {
  const [language, setLanguage] = useState(null)
  const [langFooter, setLangFooter] = useState(null)
  const [popupCalendly, setPopupCalendly] = useState(false)

  const closePopupCalendly = () => {
    setPopupCalendly(false)
  }

  // Toggle language du menu mobile
  const toggleLanguage = () => {
    if (langFooter === 'english') {
      props.getLanguage('1')
      sessionStorage.setItem('langFooter', 'french')
      setLanguage(1)
      setLangFooter('french')
    } else if (langFooter === 'french') {
      props.getLanguage('0')
      sessionStorage.setItem('langFooter', 'english')
      setLanguage(0)
      setLangFooter('english')
    }
  }

  useEffect(() => {
    if (typeof sessionStorage !== 'undefined') {
      if((sessionStorage.getItem('langFooter') === 'english') || (localStorage.getItem('language') === '0') || (langFooter === 'english')) {
        sessionStorage.setItem('langFooter', 'english')
        props.getLanguage('0')
        setLangFooter('english')
      } if((sessionStorage.getItem('langFooter') === 'french') || (localStorage.getItem('language') === '1') || (langFooter === 'french')) {
        sessionStorage.setItem('langFooter', 'french')
        props.getLanguage('1')
        setLangFooter('french')
      }
    }
  }, [langFooter,props])

  let langDir
  if (langFooter === 'english') {
    langDir = '/en/'
  } else if (langFooter === 'french') {
    langDir = '/fr/'
  }

  const keyPress = () => {}

  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="columns col-lg-4 col-md-12 col-sm-12 col-xs-12 col-12">
            <Link to={language === 0 ? '/en/' : '/fr/'} className="logo"><img src="../logos/logo-flitdesk.svg" alt="Flidesk"/></Link>
          </div>
          <div className="columns col-lg-8 col-md-12 col-sm-12 col-xs-12 col-12">
              <ul>
                {/* <li><Link to={`${langDir}solutions-startups`}>Solutions</Link></li> */}
                <li><Link to={langFooter === 'english' ? '/en/features' : langFooter === 'french' ? '/fr/fonctionnalites' : ''}>{langFooter === 'english' ? 'Features' : 'Fonctionnalités'}</Link></li>
                <li><Link to={`${langDir}integration`}>{langFooter === 'english' ? 'Integrations' : 'Intégrations'}</Link></li>
              </ul>
              <ul>
                <li><Link to={langFooter === 'english' ? '/en/about' : langFooter === 'french' ? '/fr/a-propos' : ''}>{langFooter === 'english' ? 'About' : 'À Propos'}</Link></li>
                <li><a href='https://mailchi.mp/d087db108509/flitdesk-newsletter' rel="noopener noreferrer" target="_blank">Newsletter</a></li>
                {/* <li><a href="https://medium.com/@curiosity_keys/" rel="noopener noreferrer" target="_blank">Blog</a></li> */}
              </ul>
              <ul>
                <li><span role="row" tabIndex={0} onKeyPress={keyPress} onClick={(e) => setPopupCalendly(true)}>{langFooter === 'english' ? 'Schedule a demo' : 'Planifier une démo'}</span></li>
                {/* <li><Link to={this.state.langFooter === 'english' ? '/start-free-trial' : this.state.langFooter === 'french' ? '/commencer-essai-gratuit' : ''}>{this.state.langFooter === 'english' ? 'Start free trial' : 'Commencer un essai gratuit'}</Link></li> */}
              </ul>
          </div>
        </div>
        <div className="row">
          <ul>
            <li><Link to={langFooter === 'english' ? '/en/terms-and-conditions' : '/fr/conditions-generales'}>{langFooter === 'english' ? 'Terms' : 'Conditions générales'}</Link></li>
            <li><Link to={langFooter === 'english' ? '/en/privacy-policy' : '/fr/politique-confidentialite'}>{langFooter === 'english' ? 'Privacy' : 'Politique de confidentialité'}</Link></li>
          </ul>

          <ul className="logos-footer">
            <li><img src="../logos/logo-french-tech.png" alt="Simplifier la gestion des bureaux et des espaces de travail modernes"/></li>
          </ul>

          <ul className="lang">
            <li className={langFooter  === 'english' ? 'french checked' : langFooter  === 'french' ? 'english checked' : ''}><button onClick={(e) => toggleLanguage()}/></li>
          </ul>
          <p className="lang">{langFooter === 'english' ? 'Français' : 'English'}</p>
        </div>
      </div>
      <Calendly data={popupCalendly} closePopup={closePopupCalendly}/>
    </footer>
  )
}

export default Footer